export function SectionLabel({ n, children, dark = false }) {
  return (
    <div
      className="font-mono-label text-xs tracking-label uppercase flex items-center gap-3"
      data-testid={`section-label-${n}`}
    >
      <span className="text-logo-blue">{n}</span>
      <span className={`h-px w-8 ${dark ? "bg-ink/30" : "bg-white/25"}`} />
      <span className="text-logo-blue">{children}</span>
    </div>
  );
}
